module.exports = __webpack_public_path__ + "media/images/athletes/1435-4dca3371d7bd8d9466a46a2f29cc635e.png";